import { Helmet } from "react-helmet-async"
import {
	ServicesDetails,
	TTransportServiceLocation,
} from "../../../../TransportServices"
import { useOutletContext } from "react-router"
import { useGetBackUrlFromLocation } from "@sembark-travel/ui/router"

export default function ServiceLocationBasicDetailsPage() {
	const { serviceLocation, revalidate } = useOutletContext<{
		serviceLocation: TTransportServiceLocation
		revalidate: () => void
	}>()
	const backUrl = useGetBackUrlFromLocation()
	const array = backUrl?.split(/[?&]/)
	return (
		<>
			<Helmet>
				<title>Transport Service Details</title>
			</Helmet>
			<ServicesDetails
				services={serviceLocation.services}
				mutate={revalidate}
				isDisable={array?.includes("disabled_only=1") || false}
				type="transport"
				heading="Services"
			/>
		</>
	)
}
